import Cookies from 'universal-cookie/es6'

import { STORAGEKEYS } from '../../common/keys'
import { affiliatePartnersNames } from '../../pages/AffiliatePage/affiliatePartnersData'
import { Environment } from '../../environment/app-settings'


//#region EHelikonService Instance
let eHelikonInstance: EHelikonService
//#endregion

class EHelikonService {
   private readonly _eHelikonCallbackBaseApiUrl = 'https://ekspresowykredyt.pl';
   private readonly _PRD_eHelikonAffiliateUrlPath = "/endpoint/opena/affiliate/postback";

   constructor() {
    if (eHelikonInstance) { //SINGLETON DESIGN PATTERN
       throw new Error("New instance cannot be created!!");
    }
 
    eHelikonInstance = this;
   }
   
   /**
    * Metoda pomocnicza zwracająca gotowy link do postbacka, wraz z odpowiednimi parametrami zapytania (query params)
   */
   private _preparePostbackLink (): string | undefined  {
      const currentAppUrl = window.location.origin
      
      const cookie = new Cookies();
      const currentAffiliateCookie = cookie.get(STORAGEKEYS.FORM_AFFILIATE_DATA_COOKIE)

      if(Boolean(currentAffiliateCookie)){
         if(currentAffiliateCookie.partnerId === affiliatePartnersNames.eHelikon){   
            if(currentAppUrl.includes(Environment.OPENA_FORM_PRD_URL)){ // LINK AFILIACYJNY DLA PRODUKCJI

               const eHelikonCallbackQueryParams = new URLSearchParams({
                  clickid: currentAffiliateCookie.urlParams.click_id,
               })
         
               return `${this._eHelikonCallbackBaseApiUrl + this._PRD_eHelikonAffiliateUrlPath}?${eHelikonCallbackQueryParams.toString()}`
            }
         }
      }
 
      return undefined
   }

   /**
    * Funkcja obsługująca mechanizm POSTBACK partnera eHelikon dla LEAD'A
   */
   public async sendLeadPostback(): Promise<void> {
      const currentAppUrl = window.location.origin
      const eHelikonCallbackUrl = this._preparePostbackLink()

      if(currentAppUrl.includes(Environment.OPENA_FORM_PRD_URL) && eHelikonCallbackUrl !== undefined){ // POSTBACK wykonujemy TYLKO NA PRODUKCJI
         await fetch(eHelikonCallbackUrl, { mode: 'no-cors', method: "GET" }).catch(e => console.error("Nie udało się wykonać zapytania Postback dla partnera eHelikon."))   
      }

      return
   }
}
 
let eHelikonService = Object.freeze(new EHelikonService())//SINGLETON DESIGN PATTERN
export default eHelikonService;